// Иконка жучка для категории «Баг в плеере».
import React from "react";

export function BugIcon({ size = 24, color = "currentColor" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
         stroke={color} strokeWidth="1.8"
         strokeLinecap="round" strokeLinejoin="round">
      <rect x="7" y="8" width="10" height="11" rx="5" />
      <path d="M9 6l-1.5-2M15 6l1.5-2" />
      <path d="M7 11H4M7 14H3.5M7 17H4" />
      <path d="M17 11h3M17 14h3.5M17 17h3" />
      <path d="M12 8v11" />
    </svg>
  );
}

export default BugIcon;
